import firstImage from "../../../images/decor/helix_tripod/1.avif"
import secondImage from "../../../images/decor/helix_tripod/2.avif"
import thirdImage from "../../../images/decor/helix_tripod/3.avif"
import mainImage from "../../../images/decor/helix_tripod/main.avif"


export const Helix =  {
    name:"Helix Tripod",
    code:'NDCON103',
    images:[firstImage, secondImage, thirdImage],
    main_image:mainImage,
    type:"Decor",
    description:[
            "The triangular shape of Helix is both striking and practical, providing ample space for showcasing your favorite items. The robust steel pipe frame offers a sleek, industrial edge, while the perforated steel sheet adds texture and visual interest. This perforation not only enhances the shelf’s aesthetic but also ensures lightweight durability.",
            "Perfect for contemporary homes, Helix transforms any wall with its modern, airy design. Its innovative combination of materials and form makes it a standout piece, offering both style and utility in one striking package."
    ],
    information:"Introducing Helix, a contemporary triangle pod shelf that redefines modern storage with its unique steel pipe frame and perforated steel sheet design. Helix merges geometric sophistication with industrial strength, creating a visually dynamic and functional shelving solution.",
}
